export const FALLBACK_COVER_COUNT = 4;
export const FALLBACK_COVER_TITLE = 'Видеоволна';
export const DATA_TEST_IDS = {
  PANEL: (id: string) => `video_wave_mediafile_settings_${encodeURIComponent(id)}`,
  DURATION: (id: string) => `video_wave_mediafile_duration_${encodeURIComponent(id)}`,
  REPEATS: (id: string) => `video_wave_mediafile_repeats_${encodeURIComponent(id)}`,
  HELPER: (id: string) => `video_wave_mediafile_duration_helper_${encodeURIComponent(id)}`,
};
